import { renderCustomElements } from 'js/customForm'
import { renderCustomSelect } from 'js/customSelect'

import './indexForm.scss';

window.renderCustomElements = renderCustomElements
window.renderCustomSelect = renderCustomSelect
